<template>
    <div>
        <a-card title="调用日志">
          <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <serviceSearch :logkey="islogkey" @searcchChange="handleSearchChange"></serviceSearch>
            <mtable ref="monitore_log_table" :style="{width:tableWidth}"></mtable>
        </a-card>
    </div>
</template>

<script>
import serviceSearch from '../servicesum/search'
import mtable from './table'

export default {
    data(){
        return {
            tableWidth:'800px',
            islogkey:true,
        }
    },
    methods:{
        onChange(){
        },
        handleSearchChange(searchKey){
            this.$refs.monitore_log_table.pagenation.current = 1;
            this.$refs.monitore_log_table.getAppSumData(searchKey);

        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
    components:{
        mtable,
        serviceSearch
    }
};
</script>

<style lang="less" scoped>

</style>
